import MuiTabPanel from "@mui/lab/TabPanel";
const TabPanel = MuiTabPanel;
export default TabPanel;
